import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yibanshixiang",
  "use": "icon-yibanshixiang-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-yibanshixiang\"><path d=\"M10.477 6.423a4.61 4.61 0 110 9.22 4.61 4.61 0 010-9.22zm.008.93a3.703 3.703 0 100 7.406 3.703 3.703 0 000-7.406zm1.15-7.081a.77.77 0 01.77.77v5.116c-.364-.161-.54-.282-.943-.356V1.725c0-.358-.15-.508-.508-.508h-9.43c-.358 0-.507.15-.507.508v10.193c0 .358.149.508.507.508H5.27c.105.408.258.587.453.95H.843a.771.771 0 01-.77-.77V1.042a.77.77 0 01.77-.771zm.909 9.038l.66.676-3.22 3.142-1.687-1.612.652-.683 1.029.982 2.566-2.505zm-7.339.51c-.049.308-.08.624-.093.946H2.385V9.82zm1.103-2.313c-.2.294-.378.611-.532.947H2.385v-.947zm3.785-2.313v.54a4.359 4.359 0 00-1.627.407H2.385v-.947h7.708zm0-2.312v.947H2.385v-.947h7.708z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/yibanshixiang.svg
// module id = 532
// module chunks = 4